import { INSIGHTS_BLOG_IMAGE1 } from "../../constants/imageConstants";
import { useServicesData } from "../../hooks/useServicesData";

export default function TechBusiness() {
  const { data } = useServicesData();

  return (
    <div className="py-20 px-4 md:px-16 relative">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <h2 className="text-4xl md:text-6xl font-medium text-white leading-tight">
              {data.techBusiness.title}
            </h2>
            <div className="text-xl space-y-6 text-gray-300">
              {data.techBusiness.description.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>

          <div className="relative">
            {/* Business meeting image placeholder */}
            <div className="rounded-2xl overflow-hidden bg-gradient-to-br from-blue-900/20 to-purple-900/20 border border-white/10">
              <img
                src={INSIGHTS_BLOG_IMAGE1}
                alt={data.techBusiness.imageAlt}
                className="w-full h-[400px] object-cover"
              />
            </div>

            {/* Floating elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl opacity-20 blur-xl"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-br from-orange-500 to-yellow-600 rounded-xl opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
